import * as signalR from "@microsoft/signalr";
import { jwtDecode } from "jwt-decode";
import { getCookie } from "./api";

export function SignalRImpl() {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_API_URL}/chatHub`, {
      withCredentials: true,
    })
    .build();
  return connection;
}


export async function closeConnection(connection) {
  if (connection) {
    await connection.stop();
  }
}
